
























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { maskDateTime } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component
export default class ViewFinanceiroTabelaPreco extends Vue {
  get filtroNome() { return this.getFinanceiroStore.nome }
  set filtroNome(value: string) { this.getFinanceiroStore.setNome(value) }

  get filtroEquipe() { return this.getFinanceiroStore.equipeProfissionalId }
  set filtroEquipe(value: string) { this.getFinanceiroStore.setEquipeProfissionalId(value) }

  get filtroHospital() { return this.getFinanceiroStore.hospitalId }
  set filtroHospital(value: string) { this.getFinanceiroStore.setHospitalId(value) }

  get equipesOptions() { return this.getFinanceiroStore.equipesOptions }
  get hospitaisOptions() { return this.getFinanceiroStore.fontePagadoras }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemTabelaPrecoProcedimento: boolean = false
  get loadingDeleteItemTabelaPrecoProcedimento() { return this.loadDeleteItemTabelaPrecoProcedimento }
  set loadingDeleteItemTabelaPrecoProcedimento(value: boolean) { this.loadDeleteItemTabelaPrecoProcedimento = value }

  loadEditarTabelaPreco: string = ''
  get loadingEditarTabelaPreco() { return this.loadEditarTabelaPreco }
  set loadingEditarTabelaPreco(value: string) { this.loadEditarTabelaPreco = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  itemToDelete: number = 0
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: number) { this.itemToDelete = value }

  get getFinanceiroStore() { return getModule(FinanceiroStore, this.$store) }
  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get itemsTabelaPreco() { return this.getFinanceiroStore.itemsTabelaPrecoDetails }

  get headers() {
    return [
      { text: 'Nome', value: 'nome', align: 'left' },
      { text: 'Criado por', value: 'criadoPor', align: 'left' },
      { text: 'Criado em', value: 'criadoEm', align: 'left' },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false }
    ]
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  async editarItemTabelaPreco(item: any) {
    this.getFinanceiroStore.setIsEdit(true)
    this.loadingEditarTabelaPreco = item.identificador

    const clone = JSON.parse(JSON.stringify(item))
    this.getFinanceiroStore.clearItemsTabelaPrecoProcedimento()
    this.getFinanceiroStore.setItemTabelaReferenciaId(item.identificador)
    this.getFinanceiroStore.setItemTabelaPreco(clone)

    this.getRecebimentoStore.setTabelaPrecoId(item.identificador)
    this.getRecebimentoStore.setIdForLoadTabelaProfissionaisById(item.identificador)

    await Promise.all([
      this.getRecebimentoStore.getTabelaPrestadores(item.identificador),
      this.getRecebimentoStore.getTabelaProfissionaisById(),
      this.getRecebimentoStore.getTabelaOperadora(item.identificador),
      this.getFinanceiroStore.getItensByTabelaDeReferenciaId()
    ])

    this.getFinanceiroStore.setModal({ name: 'criarTabelaPreco', value: true })
    this.loadingEditarTabelaPreco = ''
  }

  setItemToDelete(identificador: number) {
    this.itemToDeleteId = identificador
    this.showModalDeleteItem = true
  }

  showModalCriarTabelaPreco() {
    this.getFinanceiroStore.setIsEdit(false)
    this.getFinanceiroStore.setItemTabelaReferenciaId(0)
    this.getFinanceiroStore.setItemTabelaPreco({
      nome: '',
      equipeProfissionalId: null,
      hospitalId: null,
      pontuacaoId: null
    })
    this.getFinanceiroStore.setModal({ name: 'criarTabelaPreco', value: true })
  }

  async apagarItemTabelaPreco() {
    this.loadingDeleteItemTabelaPrecoProcedimento = true
    const response = await this.getFinanceiroStore.deleteItemTabelaPreco(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item apagado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getResults(this.getPagina)
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um problema com essa requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDeleteItemTabelaPrecoProcedimento = false
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getTabelaPrecoDetails(pagina)
    this.loadingDataTable = false
  }

  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsTabelaPrecoDetailsTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsTabelaPrecoDetailsPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsTabelaPrecoDetailsPagina(value)
  }

  filtrar() {
    this.getResults(1)
  }

  async created() {
    await this.getFinanceiroStore.getTabelaPrecoDetails(1)
    await this.getFinanceiroStore.getLocalExecucaoByFontePagadora()
    await this.getFinanceiroStore.getEquipeMedicaList()
    await this.getFinanceiroStore.getPontuacaoProfissional()
    await this.getFinanceiroStore.getAllItemsSenioridade()
    await this.getFinanceiroStore.getFontePagadoraAll()
  }
}
